import type { ReactChild } from "react";
import { createContext, useCallback, useContext, useState } from "react";

import { AlertDialog } from "@smartrent/ui";

export interface AlertContextData {
  title: string;
  description: string;

  setStatus: ({
    title,
    description,
    visible,
  }: {
    title: string;
    description: string;
    visible: boolean;
  }) => void;
}

export const alertContextDefaultData: AlertContextData = {
  title: "",
  description: "",
  setStatus: () => null,
};

export const AlertContext = createContext(alertContextDefaultData);

export const useAlert = () => useContext(AlertContext);

export const AlertProvider = ({ children }: { children: ReactChild }) => {
  const [state, setState] = useState({
    visible: false,
    title: "",
    description: "",
  });

  const setStatus = useCallback(
    ({
      title,
      description,
      visible,
    }: {
      title: string;
      description: string;
      visible: boolean;
    }) => {
      setState({ ...state, title, description, visible });
    },
    [state]
  );

  return (
    <AlertContext.Provider
      value={{
        title: state.title,
        description: state.description,
        setStatus,
      }}
    >
      {children}
      <AlertDialog
        visible={state.visible}
        onClose={() => {
          setState({ ...state, visible: false });
        }}
        title={state.title}
        description={state.description}
      />
    </AlertContext.Provider>
  );
};
